<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แผนงาน
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  readonly
                  theme="3"
                  :value="masterData.plan_master[0]?.plan_name_th"
              ></TextField>
<!--              <AutoBox-->
<!--                  theme="3"-->
<!--                  :items="masterData.plan_master"-->
<!--                  item-text="plan_name_th"-->
<!--                  item-value="id"-->
<!--                  :value="form.plan_id"-->
<!--                  @onChange="setFormField('plan_id', $event)"-->
<!--              ></AutoBox>-->
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                อุทยานวิทยาศาสตร์
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.sci_park"
                  @onChange="setFormField('sci_park', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อ - สกุล ผู้รับผิดชอบโครงการ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.pm_name"
                  @onChange="setFormField('pm_name', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ตำแหน่ง
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.pm_position"
                  @onChange="setFormField('pm_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.pm_org"
                  @onChange="setFormField('pm_org', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.pm_phone"
                  @onChange="setFormField('pm_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                โทรสาร
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.pm_fax"
                  @onChange="setFormField('pm_fax', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์มือถือ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  input-type="number"
                  max-length="10"
                  :value="form.pm_mobile_phone"
                  @onChange="setFormField('pm_mobile_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                E-mail
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.pm_email"
                  @onChange="setFormField('pm_email', $event)"
              ></TextField>
            </div>
          </div>

        </div>

      </div>


      <div class="card-part">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อ - สกุล ผู้ประสานงานโครงการ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.pc_name"
                  @onChange="setFormField('pc_name', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ตำแหน่ง
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.pc_position"
                  @onChange="setFormField('pc_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.pc_org"
                  @onChange="setFormField('pc_org', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.pc_phone"
                  @onChange="setFormField('pc_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                โทรสาร
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.pc_fax"
                  @onChange="setFormField('pc_fax', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์มือถือ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  input-type="number"
                  max-length="10"
                  :value="form.pc_mobile_phone"
                  @onChange="setFormField('pc_mobile_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                E-mail
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :value="form.pc_email"
                  @onChange="setFormField('pc_email', $event)"
              ></TextField>
            </div>
          </div>

        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import { eventBus } from "../../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "BFormGeneral",
  components: {
    TextField,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: {}
    }
  },
  computed: {
    ...mapState({
      GeneralForm: state => state.AForm.GeneralForm
    })
  },
  created () {
    if (this.isSameId && !this.masterData.form_b) this.form = this.GeneralForm
    if (this.masterData.form_b) {
      this.form = this.masterData.form_b.form_ab_general_info
    }
    eventBus.$on('bFormGeneral', () => {
      eventBus.$emit('bFormGeneralSend', this.form)
    })

    eventBus.$on('bFormSummary', () => {
      this.$store.commit('BForm/addSummaryData', {
        partOneForm: this.form
      })
    })
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>